import { AlertConstants } from '../../../components/alert/store/alert.constants'
import { makeActionCreator } from '../../../utilities'
import { VitalsConstants } from './vitals.constants'

export const saveVitals = makeActionCreator(VitalsConstants.VITALS_ACTION_SAVE, 'data')
export const setSavePatientVitalsResponse = makeActionCreator(VitalsConstants.SET_RESPONSE, 'response')
export const throwVitalsException = makeActionCreator(VitalsConstants.THROW_VITALS_EXCEPTION, 'exception')
export const logResponse = makeActionCreator(VitalsConstants.LOG_RESPONSE, 'response')
export const showAlert = makeActionCreator(AlertConstants.SHOW_ALERT, 'alert')
export const setPTA = makeActionCreator(VitalsConstants.SET_PTA, 'pta')
export const setTime = makeActionCreator(VitalsConstants.SET_TIME, 'time')
export const setDate = makeActionCreator(VitalsConstants.SET_DATE, 'date')
export const syncDateTime = makeActionCreator(VitalsConstants.SYNC_DATE_TIME)
export const syncPta = makeActionCreator(VitalsConstants.SYNC_PTA)
export const setAssessedBy = makeActionCreator(VitalsConstants.SET_ASSESSED_BY, 'assessedBy')
export const setComments = makeActionCreator(VitalsConstants.SET_COMMENTS, 'comments')
export const setBloodPressure = makeActionCreator(VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE, 'bloodPressure')
export const setBloodPressureMethod = makeActionCreator(
  VitalsConstants.SET_BLOOD_PRESSURE_METHOD,
  'bloodPressureMethod'
)
export const setBloodPressureMethodPNNV = makeActionCreator(
  VitalsConstants.SET_BLOOD_PRESSURE_METHOD_PNNV,
  'bloodPressureMethodPNNV'
)
export const setMapVital = makeActionCreator(VitalsConstants.SET_MAP_VITAL, 'mapVital')
export const setHeartRate = makeActionCreator(VitalsConstants.SET_HEART_RATE, 'heartRate')
export const setHeartRatePNNV = makeActionCreator(VitalsConstants.SET_HEART_RATE_PNNV, 'heartRatePNNV')
export const setHeartRateMethod = makeActionCreator(VitalsConstants.SET_HEART_RATE_METHOD, 'heartRateMethod')
export const setSpo2 = makeActionCreator(VitalsConstants.SET_SPO2, 'spo2')
export const setSpo2PNNV = makeActionCreator(VitalsConstants.SET_SPO2_PNNV, 'spo2PNNV')
export const setRoomAir = makeActionCreator(VitalsConstants.SET_ROOM_AIR, 'roomAir')
export const setRespirationRate = makeActionCreator(VitalsConstants.SET_RESPIRATION_RATE, 'respirationRate')
export const setRespirationRatePNNV = makeActionCreator(
  VitalsConstants.SET_RESPIRATION_RATE_PNNV,
  'respirationRatePNNV'
)
export const setRespirationRateEffort = makeActionCreator(
  VitalsConstants.SET_RESPIRATION_RATE_EFFORT,
  'respirationRateEffort'
)
export const setEcgTypeMethod = makeActionCreator(VitalsConstants.SET_ECG_TYPE_METHOD, 'ecgTypeMethod')
export const setTemperature = makeActionCreator(VitalsConstants.SET_TEMPERATURE, 'temperature', 'conditionalValue')
export const setTemperaturePNNV = makeActionCreator(VitalsConstants.SET_TEMPERATURE_PNNV, 'temperaturePNNV')
export const setTemperatureMethod = makeActionCreator(VitalsConstants.SET_TEMPERATURE_METHOD, 'temperatureMethod')
export const setEtCO2Type = makeActionCreator(VitalsConstants.SET_ETCO2_TYPE, 'etCO2Type')
export const setTemperatureType = makeActionCreator(VitalsConstants.SET_TEMPERATURE_TYPE, 'temperatureType')
export const setSpCO = makeActionCreator(VitalsConstants.SET_SPCO, 'spCO')
export const setSpCOPNNV = makeActionCreator(VitalsConstants.SET_SPCO_PNNV, 'spCOPNNV')
export const setSpMet = makeActionCreator(VitalsConstants.SET_SPMET, 'spMet')
export const setEtCO2 = makeActionCreator(VitalsConstants.SET_ETCO2, 'etCO2')
export const setEtCO2PNNV = makeActionCreator(VitalsConstants.SET_ETCO2_PNNV, 'etCO2PNNV')
export const setGlucose = makeActionCreator(VitalsConstants.SET_GLUCOSE, 'glucose')
export const setGlucosePNNV = makeActionCreator(VitalsConstants.SET_GLUCOSE_PNNV, 'glucosePNNV')
export const setGlucoseLevel = makeActionCreator(VitalsConstants.SET_GLUCOSE_LEVEL, 'glucoseLevel')
export const setLevelOfConsciousness = makeActionCreator(
  VitalsConstants.SET_LEVEL_OF_CONSCIOUSNESS,
  'levelOfConsciousness'
)
export const setSystolicBP = makeActionCreator(VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE, 'systolicBP')
export const setSystolicBPPNNV = makeActionCreator(VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE_PNNV, 'systolicBPPNNV')
export const setDiastolicBP = makeActionCreator(VitalsConstants.SET_DIASTOLIC_BLOOD_PRESSURE, 'diastolicBP')
export const setDiastolicBPPNNV = makeActionCreator(
  VitalsConstants.SET_DIASTOLIC_BLOOD_PRESSURE_PNNV,
  'diastolicBPPNNV'
)
export const setRts = makeActionCreator(VitalsConstants.SET_RTS, 'rts')
export const setPain = makeActionCreator(VitalsConstants.SET_PAIN, 'pain')
export const setPainPNNV = makeActionCreator(VitalsConstants.SET_PAIN_PNNV, 'painPNNV')
export const setPainType = makeActionCreator(VitalsConstants.SET_PAIN_TYPE, 'painType')
export const setPainQuality = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY, 'painQuality')
export const setPainQualityOnset = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_ONSET, 'onset')
export const setPainQualityOnsetUnit = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_ONSET_UNIT, 'onsetUnit')
export const setPainQualityField1 = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_FIELD1, 'field1')
export const setPainQualityField2 = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_FIELD2, 'field2')
export const setPainQualityField3 = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_FIELD3, 'field3')
export const setPainQualityField4 = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_FIELD4, 'field4')
export const setPainQualityField5 = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_FIELD5, 'field5')
export const setPainQualityField6 = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_FIELD6, 'field6')
export const setPainQualityField7 = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_FIELD7, 'field7')
export const setPainQualityComments = makeActionCreator(VitalsConstants.SET_PAIN_QUALITY_COMMENTS, 'comments')
export const setPainScales = makeActionCreator(VitalsConstants.SET_PAIN_SCALES, 'painScales')
export const setSedationScale = makeActionCreator(VitalsConstants.SET_SEDATION_SCALE, 'sedationScale')
export const setStrokeScale = makeActionCreator(VitalsConstants.SET_STROKE_SCALE, 'strokeScale', 'strokeScoreFlag')
export const setStrokeScalePNNV = makeActionCreator(VitalsConstants.SET_STROKE_SCALE_PNNV, 'strokeScalePNNV')
export const setStrokeScaleScoreTotal = makeActionCreator(
  VitalsConstants.SET_STROKE_SCALE_SCORE_TOTAL,
  'strokeScaleScoreTotal'
)
export const setVitalsStrokeScaleValues = makeActionCreator(
  VitalsConstants.SET_VITALS_STROKE_SCALE_VALUES,
  'vitalsStrokeScaleValues'
)
export const setStrokeScaleScoreTotalPNNV = makeActionCreator(
  VitalsConstants.SET_STROKE_SCALE_SCORE_TOTAL_PNNV,
  'strokeScaleScoreTotalPNNV'
)
export const setStrokeScaleScoreTotalPNNVEnabled = makeActionCreator(
  VitalsConstants.SET_STROKE_SCALE_SCORE_TOTAL_PNNV_ENABLED,
  '__isStrokeScaleScoreTotalPNNVEnabled'
)
export const setEyeOpeningResponse = makeActionCreator(VitalsConstants.SET_EYE_OPENING_RESPONSE, 'eyeOpeningResponse')
export const setEyeOpeningResponsePNNV = makeActionCreator(
  VitalsConstants.SET_EYE_OPENING_RESPONSE_PNNV,
  'eyeOpeningResponsePNNV'
)
export const setEyeOpeningResponseScore = makeActionCreator(
  VitalsConstants.SET_EYE_OPENING_RESPONSE_SCORE,
  'eyeOpeningResponseScore'
)

export const setVerbalResponse = makeActionCreator(VitalsConstants.SET_VERBAL_RESPONSE, 'verbalResponse')
export const setVerbalResponsePNNV = makeActionCreator(VitalsConstants.SET_VERBAL_RESPONSE_PNNV, 'verbalResponsePNNV')
export const setVerbalResponseScore = makeActionCreator(
  VitalsConstants.SET_VERBAL_RESPONSE_SCORE,
  'verbalResponseScore'
)
export const setMotorResponse = makeActionCreator(VitalsConstants.SET_MOTOR_RESPONSE, 'motorResponse')
export const setMotorResponsePNNV = makeActionCreator(VitalsConstants.SET_MOTOR_RESPONSE_PNNV, 'motorResponsePNNV')
export const setMotorResponseScore = makeActionCreator(VitalsConstants.SET_MOTOR_RESPONSE_SCORE, 'motorResponseScore')
export const setProtocol = makeActionCreator(VitalsConstants.SET_PROTOCOL, 'protocol')
export const resetPatientVitalsState = makeActionCreator(VitalsConstants.RESET_PATIENT_VITALS_STATE)
export const setState = makeActionCreator(VitalsConstants.SET_STATE, 'vitalState')
export const setTotalCGSScore = makeActionCreator(VitalsConstants.SET_TOTAL_GSC_SCORE, 'totalGCSScore')
export const setTotalCGSScorePNNV = makeActionCreator(VitalsConstants.SET_TOTAL_GSC_SCORE_PNNV, 'totalGCSScorePNNV')
export const checkQuickActionsRedirect = makeActionCreator(VitalsConstants.CHECK_QUICK_ACTIONS_REDIRECT)
export const setRhythm = makeActionCreator(VitalsConstants.SET_RHYTHM, 'rhythm')
export const setRhythmPNNV = makeActionCreator(VitalsConstants.SET_RHYTHM_PNNV, 'rhythmPNNV')
export const setRegularity = makeActionCreator(VitalsConstants.SET_REGULARITY, 'regularity')
export const setEcgType = makeActionCreator(VitalsConstants.SET_ECG_TYPE, 'ecgType')
export const setNihPositiveStrokeScaleScoreMap = makeActionCreator(
  VitalsConstants.SET_NIH_POSITIVE_STROKE_SCALE_SCORE_MAP,
  'nihPositiveStrokeScaleScoreMap'
)
export const setRaceStrokeScaleScoreMap = makeActionCreator(
  VitalsConstants.SET_RACE_STROKE_SCALE_SCORE_MAP,
  'raceStrokeScaleScoreMap'
)
export const addToTimeline = makeActionCreator(VitalsConstants.ADD_TO_TIMELINE, 'addToTimeline')
export const setLastVitals = makeActionCreator(VitalsConstants.SET_LAST_VITALS)
export const setShowRepeatVitals = makeActionCreator(VitalsConstants.SET_SHOW_REPEAT_VITALS, 'showRepeatVitals')
export const setShowDateTimeToast = makeActionCreator(VitalsConstants.SET_SHOW_DATE_TIME_TOAST, 'showDateTimeToast')
export const setShowPTAToast = makeActionCreator(VitalsConstants.SET_SHOW_PTA_TOAST, 'showPTAToast')
export const setIsPainRangeActivated = makeActionCreator(
  VitalsConstants.SET_IS_PAIN_RANGE_ACTIVATED,
  '__isPainRangeActivated'
)

export const setQualifier = makeActionCreator(VitalsConstants.SET_QUALIFIER, 'gcsQualifier')
export const setQualifierPNNV = makeActionCreator(VitalsConstants.SET_QUALIFIER_PNNV, 'gcsQualifierPNNV')

// APGAR
export const setApgarAppearance = makeActionCreator(VitalsConstants.SET_APGAR_APPEARANCE, 'apgarAppearance')
export const setApgarPulse = makeActionCreator(VitalsConstants.SET_APGAR_PULSE, 'apgarPulse')
export const setApgarGrimace = makeActionCreator(VitalsConstants.SET_APGAR_GRIMACE, 'apgarGrimace')
export const setApgarActivity = makeActionCreator(VitalsConstants.SET_APGAR_ACTIVITY, 'apgarActivity')
export const setApgarRespiration = makeActionCreator(VitalsConstants.SET_APGAR_RESPIRATION, 'apgarRespiration')
export const setTotalApgarScore = makeActionCreator(VitalsConstants.SET_TOTAL_APGAR_SCORE, 'totalApgarScore')
export const setTotalApgarScorePNNV = makeActionCreator(
  VitalsConstants.SET_TOTAL_APGAR_SCORE_PNNV,
  'totalApgarScorePNNV'
)
export const resetApgarFields = makeActionCreator(VitalsConstants.RESET_APGAR_FIELDS)
export const setApgar = makeActionCreator(VitalsConstants.SET_APGAR, 'apgar')
export const setManualApgarTotalChecked = makeActionCreator(
  VitalsConstants.SET_MANUAL_APGAR_TOTAL_CHECKED,
  '__manualApgarTotalChecked'
)
export const setRedirectedFrom = makeActionCreator(VitalsConstants.SET_IS_REDIRECTED_FROM, '__isRedirectedFrom')
export const setCustomVitalLabel1 = makeActionCreator(VitalsConstants.SET_CUSTOM_VITAL_LABEL1, 'customVitalLabel1')
export const setCustomVitalLabel2 = makeActionCreator(VitalsConstants.SET_CUSTOM_VITAL_LABEL2, 'customVitalLabel2')
export const setCustomVitalValue1 = makeActionCreator(VitalsConstants.SET_CUSTOM_VITAL_VALUE1, 'customVitalValue1')
export const setCustomVitalValue2 = makeActionCreator(VitalsConstants.SET_CUSTOM_VITAL_VALUE2, 'customVitalValue2')
export const setCustomVitalConfig = makeActionCreator(VitalsConstants.SET_CUSTOM_VITAL_CONFIG, 'customVitalConfig')
export const setCustomVitalLabelExists = makeActionCreator(
  VitalsConstants.SET_CUSTOM_VITAL_LABEL_EXISTS,
  '__customVitalLabelExists'
)
export const setAddVital = makeActionCreator(VitalsConstants.SET_ADD_VITAL)
export const setShockIndex = makeActionCreator(VitalsConstants.SET_SHOCK_INDEX, 'shockIndex')
export const setWithdrawalScale = makeActionCreator(VitalsConstants.SET_WITHDRAWAL_SCALES, 'withdrawalScaleCriteria')
export const setWithdrawalScaleType = makeActionCreator(
  VitalsConstants.SET_WITHDRAWAL_SCALE_TYPE,
  'withdrawalScaleType'
)
export const setWithdrawalScaleTotal = makeActionCreator(
  VitalsConstants.SET_WITHDRAWAL_SCALES_TOTAL,
  'withdrawalScaleTotal'
)
export const setWithdrawalScaleTotalPNNV = makeActionCreator(
  VitalsConstants.SET_WITHDRAWAL_SCALES_TOTAL_PNNV,
  'withdrawalScaleTotalPNNV'
)
export const setWithdrawalScaleTotalPNNVEnabled = makeActionCreator(
  VitalsConstants.SET_WITHDRAWAL_SCALES_TOTAL_PNNV_ENABLED,
  '__isWithdrawalScaleTotalPNNVEnabled'
)
export const setWithdrawalScaleTypeCleared = makeActionCreator(
  VitalsConstants.SET_WITHDRAWAL_SCALE_TYPE_CLEARED,
  '__isWithdrawalScaleTypeCleared'
)
